// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartBackSide.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartBackSide component
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import UiState from 'logic/Izenda.UiState';

import constants from 'logic/data/Izenda.ReportBodyConstants';
import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import ReportPartTypeManager from 'Izenda.ReportPartTypeManager';
import ReportPartFrontSide from './Izenda.ReportPartFrontSide';
import AppGlobal from 'Izenda.AppGlobal';

@observer
export default class ReportPartBackSide extends Component {
  render() {
    const {
      stateReview,
      reportPart: { type }
    } = this.props;
    const reportConfig = ReportPartTypeManager.getReportPartType(type);
    const ReportPartComponent = reportConfig.component;

    if (reportConfig.value === REPORT_PART_TYPE.Form) {
      return (
        <div className="izenda-ReportPartBackSide">
          <div className="report-part-parent-panel u_fullSize">
            <ReportPartComponent.BackSide {...this.props} />
          </div>
        </div>
      );
    }

    if (UiState.isMobile) {
      return (
        <div className="izenda-ReportPartBackSide">
          <div className="report-part-parent-panel u_fullSize">
            <ScrollBox>
              <ReportPartComponent.BackSide {...this.props} />
            </ScrollBox>
          </div>
        </div>
      );
    }

    const leftPanelClasses = classnames('child-panel u_tableCell u_alignTop', {
      hide: stateReview === constants.DIRECTION_STATE.RIGHT,
      'child-panel-expanded': stateReview === constants.DIRECTION_STATE.LEFT
    });
    const rightPanelClasses = classnames('child-panel u_tableCell u_alignTop', {
      hide: stateReview === constants.DIRECTION_STATE.LEFT,
      'child-panel-expanded': stateReview === constants.DIRECTION_STATE.RIGHT
    });

    return (
      <div className="izenda-ReportPartBackSide">
        <div className="report-part-parent-panel izenda-TableLayout">
          <div className={leftPanelClasses}>
            <div className="report-part-panel">
              <ScrollBox>
                <div className="report-part-panel-content panel-content">
                  <ReportPartComponent.BackSide {...this.props} />
                </div>
              </ScrollBox>
            </div>
          </div>

          {AppGlobal.canShowPreview() && (
            <div className={rightPanelClasses}>
              <ReportPartBackSidePreview {...this.props} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

class ReportPartBackSidePreview extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.stateReview === this.props.stateReview;
  }

  render() {
    return (
      <div className="report-part-panel">
        <ScrollBox>
          <div className="report-part-panel-content panel-content">
            <ReportPartFrontSide {...this.props} isPreview />
          </div>
        </ScrollBox>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/Izenda.ReportPartBackSide.js